import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    CardActions,
    TextField,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";


export default function WebhookUrlCard({
    webhookUrl,
    onConfirm,
    loading,
    error,
    isSuccess,
}) {
    const { t } = useTranslation();

    const [tempWebhookUrl, setTempWebhookUrl] = useState('')

    useEffect(() => {
        if (!!webhookUrl) {
            setTempWebhookUrl(webhookUrl)
        }
    }, [webhookUrl])

    const isValidUrl = (url) => {
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    };

    const confirmHandler = () => {
        onConfirm({ webhookUrl: tempWebhookUrl })
    }

    return (
        <Card>
            <CardHeader title={t("DMS Webhook URL")} />
            <Divider />
            <CardContent>
                <TextField
                    name="webhookUrl"
                    value={tempWebhookUrl}
                    onChange={({ target: { value } }) => setTempWebhookUrl(value)}
                    variant="outlined"
                    label={t("Webhook URL")}
                    placeholder={t("Webhook URL")}
                    size="small"
                    fullWidth
                />
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={confirmHandler}
                    disabled={!isValidUrl(tempWebhookUrl)}
                    sx={{ textTransform: 'none' }}
                >{t("Confirm")}
                </LoadingButton>
                {isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
            </CardActions>
        </Card>
    );
};

